import React from 'react';
import PropTypes from 'prop-types';

import Table from '@appComponents/Table';
import {rowRenderer} from '@modules/reports/reportsRowRenderer';

const columns = {
    'event_content_start_datetime': {
        label: 'Time',
        sorting: true,
        className: '--noWrap-time',
        header: {
            align: 'left',
        },
        content: {
            align: 'left',
        },
    },
    'content': {label: 'Content', sorting: false},
};

export const EventContentsTable = ({ data, loading }) => {
    return <Table
        columns={columns}
        data={data}
        loading={loading}
        name='contentStreamingReportList'
        rowRenderer={rowRenderer}
        noDataText={'No event contents found.'}
    />;
};

EventContentsTable.propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
};
